// src/components/BookCard.js
import React from 'react';
import '../styles/BookCard.css';
import placeholder from '../assets/placeholder.jpg'; 
import { Link } from 'react-router-dom';

const BookCard = ({ book }) => {
  const { id, title, author, coverImage } = book;

  return (
    <div className="book-card">
      <Link to={`/book/${id}`}>
        <img
          src={coverImage || placeholder}
          alt={title}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
        />
      </Link>
    </div>
  );
};

export default BookCard;